import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  UserIcon,
  CurrencyDollarIcon,
  PhoneIcon,
} from "@heroicons/react/24/solid";
import Autocomplete from "../../../components/Places/PlacesAutocomplete";
import FormInput from "../../../components/controls/FormInput";

const EventCreationGeneralInformation = ({
  nextStep,
  updateEventData,
  eventData,
}) => {
  const { t } = useTranslation();
  const [name, setName] = useState(eventData.name || "");
  const [attendees, setAttendees] = useState(eventData.attendees || 0);
  const [budget, setBudget] = useState(eventData.budget || 0);
  const [location, setLocation] = useState(eventData.location || "");
  const [contactPhone, setContactPhone] = useState(
    eventData.contactPhone || ""
  );
  const [errors, setErrors] = useState({});

  const handleNextStep = () => {
    if (validateFields()) {
      updateEventData({ attendees, budget, location, name, contactPhone });
      nextStep();
    }
  };

  const validateFields = () => {
    let errors = {};
    if (!attendees) errors.attendees = t("errors.attendees");
    if (!budget) errors.budget = t("errors.maximumBudget");
    if (!location) errors.location = t("errors.location");
    if (!name) errors.name = t("errors.eventName");
    if (!contactPhone) errors.contactPhone = t("errors.phoneNumberInvalid");

    if (Object.keys(errors).length > 0) {
      setErrors(errors);

      return false;
    } else {
      setErrors({});
      return true;
    }
  };

  const handleLocationSelect = (data) => {
    setLocation(data);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm w-full max-w-lg overflow-hidden border border-gray-100">
      <div className="bg-gradient-to-b from-[#f0f9ff] to-white p-6">
        <h2 className="text-xl font-bold text-center text-gray-800">
          {t("stepOne.title")}
        </h2>
      </div>

      <div className="px-8 py-4">
        {/* Formulaire */}
        <div className="space-y-6 ">
          <FormInput
            label={t("stepOne.eventName.label")}
            type="text"
            value={name}
            onChange={(name, value) => setName(value)}
            placeholder={t("stepOne.eventName.placeholder")}
            required={true}
            icon={<UserIcon className="w-5 h-5 text-gray-500" />}
            error={errors.name}
          />

          {/* Nombre de personnes */}
          <FormInput
            label={t("stepOne.attendees.label")}
            type="number"
            value={attendees}
            onChange={(name, value) => setAttendees(Number(value))}
            placeholder={t("stepOne.attendees.placeholder")}
            required={true}
            onFocus={(e) => {
              if (e.target.value === "0") {
                e.target.value = "";
              }
            }}
            icon={<UserIcon className="w-5 h-5 text-gray-500" />}
            error={errors.attendees}
          />

          <FormInput
            label={t("becomeProvider.phoneNumberLabel")}
            type="tel"
            value={contactPhone}
            onChange={(name, value) => setContactPhone(value)}
            placeholder={t("becomeProvider.phoneNumberPlaceholder")}
            required={true}
            onFocus={(e) => {
              if (e.target.value === "0") {
                e.target.value = "";
              }
            }}
            icon={<PhoneIcon className="w-5 h-5 text-gray-500" />} // ✅ Changement de l'icône
            error={errors.contactPhone}
          />

          {/* Budget maximal */}
          <FormInput
            label={t("stepOne.budget.label")}
            type="number"
            value={budget}
            onChange={(name, value) => setBudget(Number(value))}
            placeholder={t("stepOne.budget.placeholder")}
            required={true}
            onFocus={(e) => {
              if (e.target.value === "0") {
                e.target.value = "";
              }
            }}
            icon={<CurrencyDollarIcon className="w-5 h-5 text-gray-500" />}
            error={errors.budget}
          />

          <Autocomplete
            onSelect={handleLocationSelect}
            initialAddress={location.formattedAddress}
            customError={errors.location}
          ></Autocomplete>
        </div>
        {/* Bouton Suivant */}
        <div className="mt-6 flex justify-center">
          <button
            onClick={handleNextStep}
            className="w-full bg-primary text-white py-3 rounded-full hover:bg-primary/90 transition focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
          >
            {t("stepOne.nextButton")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventCreationGeneralInformation;
